import makeRequest from "../api/makeRequest";
import url from "../api/urls";
import { RequstMethods } from "../api/requestMethode";


export interface IUserListParams {
    page?: number;
    limit?: number;
    search?: string;
    centerId?: string;
    gender?: string;
}

function buildUserQuery(params: IUserListParams) {
    const query = new URLSearchParams();
    if (params.page) query.set("page", String(params.page));
    if (params.limit) query.set("limit", String(params.limit));
    if (params.search) query.set("search", params.search);
    if (params.centerId) query.set("centerId", params.centerId);
    if (params.gender) query.set("gender", params.gender);
    return query.toString();
}

export class UserServices {
    static async getAllUser() {
        return await makeRequest(url.user.getAllUsers , RequstMethods.GET)
    }

    static async getUsers(params: IUserListParams) {
        return await makeRequest(`${url.user.list}?${buildUserQuery(params)}`, RequstMethods.GET)
    }

    static async exportUsers(params: Omit<IUserListParams, "page" | "limit">) {
        return await makeRequest(`${url.user.exportCsv}?${buildUserQuery(params)}`, RequstMethods.GET)
    }

    static async resetPasswordForUser(payload:any) {
        return await makeRequest(url.user.resetPasswordForUser , RequstMethods.PUT , payload)
    }

    static async deleteStudentMapping(id:string ) {
        return await makeRequest(url.user.deleteStudentMapping+"/"+id, RequstMethods.DELETE)
    }
    
    static async disableStudentMapping(id:string ) {
        return await makeRequest(url.user.disableStudentMapping+"/"+id, RequstMethods.PUT)
    }

    static async toggleStudentMapping(id:string){
        return await makeRequest(url.user.toggleStudentMapping+'/'+id , RequstMethods.PUT);
    }

    static async unmarkCompleted(mappingId: string){
        return await makeRequest(url.user.unMarkCompletedMapping+"/"+mappingId, RequstMethods.PUT);
    }

    static async genrateCertificate(examMappingId: string) {
        return await makeRequest(url.user.genrateCertificate + "/" + examMappingId, RequstMethods.GET)
    }

    static async toggleStatusMultiple(payload: any) {
        return await makeRequest(url.user.toggleMultipleStudentMapping, RequstMethods.PUT, payload)
    }
}